<template>
  <v-card class="meeting-feedback">
    <v-subheader>
      <v-icon medium color="indigo" class="mr-2">feedback</v-icon>
      {{date}} <span class="ml-2">Оставлен отзыв о встрече</span>
    </v-subheader>
    <v-layout row>
      <v-flex xs9 class="grey lighten-4">
        <v-card tile flat class="grey lighten-4">
          <v-card-text>
            <span class="font-weight-medium">Фидбек: </span>{{message}}
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs3 class="grey lighten-3">
        <v-card tile flat class="grey lighten-3">
          <v-layout row align-center class="mt-2 ml-3">
            <span class="font-weight-medium">Оценка: </span>
            <v-rating
              readonly
              v-model="mark"
              :color="getRatingColor(mark)"
              background-color="secondary"
              small
            ></v-rating>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </v-card>
</template>

<script>
  export default {
    name: "MeetingFeedback",
    props: [
      "date",
      "description",
      "level",
      "message",
      "mark"
    ],
    methods: {
      getRatingColor(mark) {
        if (mark >= 4) {
          return "success"
        }

        if (mark === 3) {
          return "warning"
        }

        if (mark < 3) {
          return "error"
        }
      }
    }
  }
</script>

<style scoped>
  .meeting-feedback {
    border: 1px solid #78909C;
  }

  .meeting-feedback__level {
    background-color: #F5F5F5;
  }
</style>
